module.exports = __webpack_public_path__ + "img/Arrow.c31fff29.svg";